import { nsAccount } from '@/app/i18n/namespaces';
import MERCHANT_ACCOUNT_STATUS from '../enums/merchantAccountStatus';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';


export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    ORGANIZATION_UUID: {
        key: 'provider'
    },
    EMAIL: {
        key: 'email',
        entity: 'keys.email',
        type: 'email',
        namespace: nsAccount,
        placeholder: 'filter.placeholder.email',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    STATUS: {
        key: 'status',
        type: FIELD_TYPES.BADGE,
        entity: 'keys.status',
        namespace: nsAccount,
        prefix: 'account_status_',
        enum: MERCHANT_ACCOUNT_STATUS,
        filter: FILTER_TYPES.SELECT,
        enableSorting: true
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        namespace: nsAccount,
        entity: 'keys.created_at',
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: FIELD_TYPES.DATE,
        namespace: nsAccount,
        entity: 'keys.updated_at',
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    LABEL: {
        key: 'label',
        type: 'string',
        entity: 'keys.label',
        namespace: nsAccount,
        placeholder: 'filter.placeholder.label',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    DETAILS: {
        key: 'details',
        enableSorting: false
    },
    PROVIDER: {
        key: 'provider'
    },
    X25_CENTERS: {
        key: 'x25Centers'
    }
};